import { Component, Input, OnChanges, inject, ChangeDetectionStrategy, computed, signal } from '@angular/core';
import { MedicationGridItemObject } from '@libs/types/src/services/object-type/medication/medication.object';
import { PersonService } from '../../../../../services/person.service';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { isOffline } from '../../../../../utils/connection.service';
import { Popover } from '@openng/optimus-ui/popover';
import { TranslatePipe } from '@ngx-translate/core';
import { LinkButtonComponent } from '../../../../../components/kit/button/link-button.component';
import { Skeleton } from '@openng/optimus-ui/skeleton';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-medication-info',
    templateUrl: 'medication-info.component.html',
    styleUrls: ['medication-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Popover,
        TranslatePipe,
        LinkButtonComponent,
        Skeleton,
    ],
})
export class MedicationInfoComponent implements OnChanges {
    private readonly fetch = inject(PersonService);

    @Input() medicationCode!: string;

    public readonly medication = signal<MedicationGridItemObject | null | undefined>(undefined);

    public readonly label = computed(() => {
        const medication = this.medication();
        if (medication === undefined) return undefined;
        return medication ? `${medication.name ?? ''} ${medication.nameAddition ?? ''}`.trim() : this.medicationCode;
    });

    public async ngOnChanges(): Promise<void> {
        const code = this.medicationCode;
        this.medication.set(undefined);
        const medications = await lastValueFrom(this.fetch.getMedications(FilterBuilder.singleItem({ code })), {
            defaultValue: null,
        });
        if (code !== this.medicationCode) return;
        this.medication.set(medications?.items?.[0] ?? null);
    }

    protected readonly isOffline = isOffline;
}
